import { Container, Box, Typography } from '@mui/material';
import MuiButton from '@mui/material/Button';
import { FC, useEffect, useState } from 'react';
import LogoFull from '../LogoFull';

export interface IThanksForSubscribingProps {
  signUpRedirectUrl: string | null;
}

const REDIRECT_TIME_IN_SECONDS = 5;

const ThanksForSubscribing: FC<IThanksForSubscribingProps> = ({
  signUpRedirectUrl,
}) => {
  const [counter, setCounter] = useState<undefined | number>();
  useEffect(() => {
    if (signUpRedirectUrl) {
      setCounter(REDIRECT_TIME_IN_SECONDS);
      const updateCounterInterval = setInterval(() => {
        setCounter((prevState) => {
          if (prevState === undefined) {
            return REDIRECT_TIME_IN_SECONDS;
          } else {
            return prevState > 0 ? prevState - 1 : 0;
          }
        });
      }, 1000);
      const redirectTimeout = setTimeout(() => {
        window.location.href = signUpRedirectUrl;
      }, REDIRECT_TIME_IN_SECONDS * 1000);

      return () => {
        clearInterval(updateCounterInterval);
        clearTimeout(redirectTimeout);
      };
    }
  }, [signUpRedirectUrl]);

  return (
    <Container
      maxWidth={'sm'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        mt: 2,
        mb: 2,
        pb: 2,
        pt: 2,
      }}
    >
      {!signUpRedirectUrl && (
        <Box sx={{ width: 285, height: 90 }}>
          <LogoFull disabledLink />
        </Box>
      )}

      <Typography variant="h3" data-testid="thanks-for-subscribing-header">
        Thank you for subscribing!
      </Typography>
      <Typography
        variant="h6"
        sx={{ color: 'text.secondary', textAlign: 'center', fontWeight: 300 }}
      >
        {signUpRedirectUrl && (
          <>You will be redirected shortly... [{counter}]</>
        )}
        {!signUpRedirectUrl && (
          <>
            If you have any questions or are interested in learning how to build
            your own SMS membership, click below.
          </>
        )}
      </Typography>

      {!signUpRedirectUrl && (
        <MuiButton
          href="https://www.subflow.com"
          variant="contained"
          sx={{ mt: 2 }}
        >
          Learn About Subflow
        </MuiButton>
      )}
    </Container>
  );
};

export default ThanksForSubscribing;
